import { formatDate } from '@angular/common';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { DfApiConfigService } from '@df/api/config/df-api-config.service';
import { NUi } from '../df-ui.config';

@Pipe({
    name: 'formatDate',
    standalone: true
})
export class FormatDatePipe implements PipeTransform {
    constructor(
        @Inject(NUi.OPTIONS) private uiConfig: NUi.IModuleOptions,
        private dfApiConfigService: DfApiConfigService
    ) {}

    transform(input: string | number | Date): string | undefined {
        if (!input) {
            return undefined;
        }
        return formatDate(input, this.uiConfig.date.format, this.dfApiConfigService.apiConfig!.locale);
    }
}
